/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ProductFiltersDto } from './product-filters-dto';
/**
 * 
 * @export
 * @interface PersonalizedProductsQueryDto
 */
export interface PersonalizedProductsQueryDto {
  _id?: string;
    /**
     * Page number
     * @type {number}
     * @memberof PersonalizedProductsQueryDto
     */
    page?: number;
    /**
     * Number of items per page
     * @type {number}
     * @memberof PersonalizedProductsQueryDto
     */
    limit?: number;
    /**
     * Percentage of personalized products (0-100)
     * @type {number}
     * @memberof PersonalizedProductsQueryDto
     */
    personalizedRatio?: number;
    /**
     * Place admin-selected featured products before personalized and regular products
     * @type {boolean}
     * @memberof PersonalizedProductsQueryDto
     */
    featuredFirst?: boolean;
    /**
     * Start of the current browsing session. Views after this timestamp are learned for the next session.
     * @type {string}
     * @memberof PersonalizedProductsQueryDto
     */
    personalizationSessionStartedAt?: string;
    /**
     * Sort order
     * @type {string}
     * @memberof PersonalizedProductsQueryDto
     */
    sort?: PersonalizedProductsQueryDtoSortEnum;
    /**
     * Comma-separated brand names
     * @type {string}
     * @memberof PersonalizedProductsQueryDto
     */
    brandFilter?: string;
    /**
     * Product filters
     * @type {ProductFiltersDto}
     * @memberof PersonalizedProductsQueryDto
     */
    filters?: ProductFiltersDto;
}

/**
    * @export
    * @enum {string}
    */
export enum PersonalizedProductsQueryDtoSortEnum {
    Latest = 'latest',
    PriceAsc = 'price_asc',
    PriceDesc = 'price_desc',
    Rating = 'rating',
    Popularity = 'popularity'
}
